import React from "react";
import { useTranslation } from "react-i18next";
import SiteHeader from "../SiteHeader";
import "../../assets/RegistrationForm.css";
import "../../assets/TopicPage.css";

// Consent (2026-10-10): content to be supplied by the PI.
const ConsentPage = () => {
    const { t } = useTranslation();
    return (
        <div className="appContainer">
            <SiteHeader />
            <main className="content" style={{ maxWidth: "800px", margin: "0 auto", paddingLeft: "20px", paddingRight: "20px", alignItems: "stretch" }}>
                <h1 className="topic-page__heading">{t("consent.heading")}</h1>
                <section className="topic-page__content topic-page__content--single">
                    <p>{t("consent.body")}</p>
                </section>
            </main>
        </div>
    );
};

export default ConsentPage;
